export async function convertWithCloudConvert({
  fileUrl,
  fileName,
  convertTo,
  websiteUrl,
  accessToken,
}: {
  fileUrl?: string;
  fileName?: string;
  convertTo?: string;
  websiteUrl?: string;
  accessToken?: string;
}): Promise<string> {
  const res = await fetch(
    `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/cloudconvert`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      body: JSON.stringify({
        fileUrl,
        fileName,
        convertTo,
        websiteUrl,
      }),
    }
  );
  if (!res.ok) {
    let errText = await res.text();
    try {
      const json = JSON.parse(errText);
      errText = json.error || errText;
    } catch {}
    console.error("CloudConvert function error", res.status, errText);
    throw new Error(`CloudConvert failed: ${errText}`);
  }
  const { url } = await res.json();
  return url;
} 